export enum QueryKey {
  ME = "me",
  PAYOUTS = "payouts",
  ACQUIRED_USERS = "acquired-users",
}
